import { Injectable } from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  // Converts a string to NgbDateStruct (parsing)
  parse(value: string): NgbDateStruct | null {
    if (value) {
      // Expecting dd-MM-yyyy
      const dateParts = value.trim().split('-');
      if (dateParts.length === 3) {
        return {
          day: parseInt(dateParts[0], 10),
          month: parseInt(dateParts[1], 10),
          year: parseInt(dateParts[2], 10),
        };
      }
    }
    return null;
  }

  // Converts an NgbDateStruct to string (formatting)
  format(date: NgbDateStruct | null): string {
    return date
      ? `${this.pad(date.day)}-${this.pad(date.month)}-${date.year}`
      : '';
  }

  // Helper to add a leading zero to single-digit numbers
  private pad(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
}
